// src/components/Footer.js
import React from "react";
import { Link } from "react-router-dom";

const year = new Date().getFullYear();

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 text-sm">
      <div className="max-w-7xl mx-auto grid gap-10 md:grid-cols-4 px-6 py-14">
        {/* BRAND */}
        <div>
          <h3 className="text-xl font-extrabold text-white mb-4">
            Rent&nbsp;&amp;&nbsp;Klart
          </h3>
          <p>
            Din lokala städfirma i Kristinehamn med miljövänliga produkter och
            nöjd-kund-garanti. Fakturering via&nbsp;
            <span className="font-semibold text-white">Frilans&nbsp;Finans</span>.
          </p>
        </div>

        {/* QUICK LINKS */}
        <div>
          <h4 className="text-white font-semibold mb-3">Snabblänkar</h4>
          <ul className="space-y-2">
            <li>
              <Link to="/" className="hover:text-white">
                Hem
              </Link>
            </li>
            <li>
              <Link to="/tjanster" className="hover:text-white">
                Tjänster
              </Link>
            </li>
            <li>
              <Link to="/om-oss" className="hover:text-white">
                Om oss
              </Link>
            </li>
            <li>
              <Link to="/kontakt" className="hover:text-white">
                Kontakt
              </Link>
            </li>
            <li>
              <Link to="/integritet" className="hover:text-white">
                Integritet&nbsp;&amp;&nbsp;Cookies
              </Link>
            </li>
          </ul>
        </div>

        {/* SERVICES */}
        <div>
          <h4 className="text-white font-semibold mb-3">Tjänster</h4>
          <ul className="space-y-2">
            <li>Hemstädning</li>
            <li>Jour&nbsp;/&nbsp;Akutstädning</li>
            <li>Kontorsstädning</li>
            <li>Trappstädning</li>
            <li>Bär&nbsp;/&nbsp;Vardagshjälp</li>
          </ul>
        </div>

        {/* CONTACT */}
        <div>
          <h4 className="text-white font-semibold mb-3">Kontakt</h4>
          <p>Kristinehamn, Sverige</p>
          <a
            href="tel:+46734877119"
            className="block hover:text-white mt-2"
          >
            +46&nbsp;73&nbsp;487&nbsp;71&nbsp;19
          </a>
          <a
            href="mailto:info@rentklart.se"
            className="block hover:text-white"
          >
            info@rentklart.se
          </a>

          {/* SOCIAL ICONS */}
          <div className="flex space-x-4 mt-6">
            <a
              href="#"
              aria-label="Facebook"
              className="hover:text-white transition"
            >
              <svg
                className="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M22 12A10 10 0 1010.5 22v-7H8v-3h2.5V9.5C10.5 7 12 5.6 14.3 5.6c1.1 0 2.2.2 2.2.2v2.5h-1.2c-1.2 0-1.6.8-1.6 1.6V12H18l-.5 3h-2.7v7A10 10 0 0022 12z" />
              </svg>
            </a>
            <a
              href="#"
              aria-label="Instagram"
              className="hover:text-white transition"
            >
              <svg
                className="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M12 2.2c3.2 0 3.6 0 4.9.1 1.2.1 1.9.3 2.4.5.6.2 1 .5 1.5 1 .5.5.8.9 1 1.5.2.5.4 1.2.5 2.4.1 1.3.1 1.7.1 4.9s0 3.6-.1 4.9c-.1 1.2-.3 1.9-.5 2.4-.2.6-.5 1-1 1.5-.5.5-.9.8-1.5 1-.5.2-1.2.4-2.4.5-1.3.1-1.7.1-4.9.1s-3.6 0-4.9-.1c-1.2-.1-1.9-.3-2.4-.5-.6-.2-1-.5-1.5-1-.5-.5-.8-.9-1-1.5-.2-.5-.4-1.2-.5-2.4C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.9c.1-1.2.3-1.9.4-2 .2-.5.4-.8.7-1.1.3-.3.6-.6 1.1-.7.4-.1 1-.3 2-.4 1.3-.1 1.7-.1 4.8-.1zm0 3.8a5 5 0 110 10 5 5 0 010-10zm4.8-1.3a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" />
              </svg>
            </a>
          </div>
        </div>
      </div>

      {/* COPYRIGHT */}
      <div className="border-t border-gray-700 text-center py-4 text-xs">
        &copy; {year} Rent &amp; Klart. Alla rättigheter förbehållna.
      </div>
    </footer>
  );
}
